import {getElement} from "./utils/getElement";

const initDropdown = () => {
    const dropdownBtn = getElement('.js-dropdown-toggle')

    if (!dropdownBtn)
        return null;

    dropdownBtn.addEventListener('click', () => {
        if (dropdownBtn.classList.contains('is-open')) {
            dropdownBtn.classList.remove('is-open')
        } else {
            dropdownBtn.classList.add('is-open')
        }
    })

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.js-dropdown-toggle')) {
            dropdownBtn.classList.remove('is-open')
        }
    })
}

export {initDropdown}